import script from "./cryptoWithdraw.vue?vue&type=script&setup=true&lang=ts"
export * from "./cryptoWithdraw.vue?vue&type=script&setup=true&lang=ts"

import "./cryptoWithdraw.vue?vue&type=style&index=0&id=5778a96c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5778a96c"]])

export default __exports__